import React from "react";
// import Header1 from "../../../Header1";
import "./style/style.css";

const AboutUs = () => {
	return (
		<>
			{/* <Header1/>		 */}
			<section 
				className="p-0 wow fadeInUp"
				data-wow-duration="2s"
				data-bg-img="images/pattern/03.png"
			>
				<div className="container">
					<div className="row custom-mt-10">
						<div className="col-lg-8 col-md-12 ml-auto mr-auto">
							<div className="video-box">
								<img
									className="img-fluid"
									src="images/mackbook/01.png"
									alt=""
								/>
								<div className="video-btn video-btn-pos">
									{" "}
									<a
										className="play-btn popup-youtube"
										href="https://www.youtube.com/watch?v=P_wKDMcr1Tg"
									>
										<i className="la la-play"></i>
									</a>
									<div className="spinner-eff">
										<div className="spinner-circle circle-1"></div>
										<div className="spinner-circle circle-2"></div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className="row text-center mt-5">
						<div className="col-lg-10 col-md-12 ml-auto mr-auto">
							<h2 className="text-black font-weight-normal line-h-2">
								N-Code{" "}
								<span className="text-theme">Tecnologia</span>{" "}
							</h2>
							<h4 className="">
								Uma empresa criada por profissionais de Sistemas,  {" "}
								<span className="text-theme">
									mas que entendem de pessoas.
								</span>{" "}
								Criamos o que você precisa da forma que você precisa.
							</h4>
							<h2>
								Somos a N-Code.
							</h2>
						</div>
					</div>
				</div>
			</section>
		</>
	);
};
export default AboutUs;
